<template>
  <div v-loading="loading">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addOrUpdate(null)">新增监管员</el-button>
    </el-card>
    <el-card>
      <el-table :data="listData" style="width: 100%" :height="heightStyleObj" highlight-current-row border stripe>
        <template slot="empty">
          <el-empty description="暂无数据"></el-empty>
        </template>
        <el-table-column prop="name" label="监管员姓名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="手机号码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="{row }">
            {{ row.createTime ? parseTime(row.createTime) : null }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" active-color="#13ce66" active-value="1" inactive-value="0"
              @change="changeStatus(row, $event)">
            </el-switch></template>
        </el-table-column>
        <el-table-column prop="created" label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="addOrUpdate(row)">编辑</el-button>
            <el-button type="text" @click="deleteRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getList" />
    </el-card>
    <addOrUpdateSupervisor v-if="addOrUpdateVisible" :visible="addOrUpdateVisible" :supervisor-info="supervisorInfo"
      @close="close" />
  </div>
</template>

<script>
import { getSupervisorList } from '@/api/antiFake/supervisor'
import { getDict } from '@/api/common'
import addOrUpdateSupervisor from './components/addOrEdit.vue'
import { updateSupervisor, deleteSupervisor } from '../../../api/antiFake/supervisor'
export default {
  components: { addOrUpdateSupervisor },
  data() {
    return {
      listData: [],
      loading: false,
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          placeholder: '姓名/手机号码',
          width: '300px',
          type: 'input'
        },
        {
          label: '创建时间',
          field: 'datetime',
          type: 'date'
        },
        {
          label: '状态',
          field: 'Status',
          type: 'selected',
          options: []
        },
      ],
      dictObj: {
        supervisor_status: []
      },
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchValue: null,
        datetime: []
      },
      heightStyleObj: '',
      supervisorInfo: {},
      addOrUpdateVisible: false
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'

    this.getList()
    this.getDicts(['supervisor_status'])

  },
  methods: {
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.search()
    },
    search() {
      this.searchParam.pageNum = 1
      this.getList()
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'supervisor_status') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'Status')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
    // 处理状态变更
    changeStatus(row) {
      const that = this
      const message = row.status === '0' ? '停用后该监管员将无法查看窜货信息，您确定要停用吗？' : '您确定要启用吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        updateSupervisor(row).then(() => {
          that.getList()
        }).finally(() => {
          that.loading = false
        })
      }).catch(()=>{
        that.getList()
      })

    },
    getList() {
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.datetime) {
        const [startTimeStr, endTimeStr] = searchParam.datetime
        searchParam.startTimeStr = startTimeStr
        searchParam.endTimeStr = endTimeStr
        delete searchParam.datetime
      }
      this.loading = true
      getSupervisorList(searchParam).then((res) => {
        this.listData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },

    // 编辑或更新监管员
    addOrUpdate(row) {
      console.log(row);
      if (row) {
        this.supervisorInfo = JSON.parse(JSON.stringify(row))
      }
      this.addOrUpdateVisible = true
    },
    // 关闭弹窗
    close() {
      this.addOrUpdateVisible = false
      this.supervisorInfo = {}
      this.getList()
    },

    deleteRow(row) {
      this.$confirm(`删除后无法恢复，您确定要删除${row.name}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.loading = true
        deleteSupervisor(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList()
        }).finally(() => {
          this.loading = false
        })
      })
    },
  }
}
</script>
